import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
const useStyles = makeStyles(theme => ({
  Section: {
    background: props =>
      props.kitchen ? theme.palette.background.paper : "transparent",
  },
  Container: {
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
    margin: "auto",
    padding: theme.spacing(16, 2, 30, 2),
    "& h2": {
      textAlign: "center",
      fontSize: theme.typography.fontSize + 20,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(6),
    },
  },
  Grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 39em))",
    gridAutoRows: "auto",
    gap: "2em",
    justifyContent: "center",
    alignItems: "center",
  },
  GridItem: {
    width: "100%",
    height: "100%",
  },
  Paper: {
    margin: "auto",
    padding: theme.spacing(6, 6),
    width: "100%",
    height: "100%",
    backgroundColor: "pink",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(4, 2),
      height: "fit-content",
      textAlign: "center",
    },
  },
  head: {
    display: "inline-flex",
    alignItems: "center",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(2),
    },
  },
  imageBox: {
    borderRadius: "50%",
    background: theme.palette.primary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(2),
  },
}))
export default ({ kitchen }) => {
  const classes = useStyles({ kitchen })
  const content = [
    {
      id: 4564,
      img: "",
      name: "Mrs Esther Udoma",
      text:
        "I want to say a very big thanks to your team, they came through and served professionaly, everything was on budget, may god bless you",
    },
    {
      id: 4565,
      img: "",
      name: "Mikel Adeyemi",
      text: `I never thought the Anniversary would have been this much colorful and packed with so much activities.`,
    },
  ]
  return (
    <Box className={classes.Section} id="testimonials">
      <Box className={classes.Container}>
        <Typography variant="h2">OUR CLIENTS THOUGHT</Typography>
        <Box className={classes.Grid}>
          {content.map(data => (
            <Box className={classes.GridItem} key={data.id.toString()}>
              <Paper className={classes.Paper}>
                <Box className={classes.head}>
                  <Box className={classes.imageBox}></Box>
                  <Typography>{data.name}</Typography>
                </Box>
                <Typography>{data.text}</Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
